import React from "react"
import DOMPurify from "dompurify"

// components
import Snippets from "app/static/frontend/search-new/components/Inline/components/Snippets"
// helper functions
import { renderText } from "app/static/frontend/search-new/components/Inline/shared/functions"
import { stringContainsHTMLMarkup, checkParseAlertString, parseDateTime } from "shared/imports/sharedHelperFunctions"

import { useStyles } from "@/components/MobileAlertCard/Body/Body.styles"

// Heavily inspired by search-new/components/Inline/components/FeedItem.js
export const Body = ({
    bigCache,
    isSearchify,
    inlineId,
}: {
    bigCache: { fields: Array<{ label: string; values: Array<string> }>; date_with_tz: string }
    isSearchify: boolean
    inlineId: number
    quorumDataType: object
    isMobile: boolean
}) => {
    const { classes } = useStyles()

    if (bigCache) {
        const formatValues = (label, values) => {
            if (label === "Created:" && bigCache.date_with_tz) {
                return [parseDateTime(bigCache.date_with_tz)]
            }

            if (label === "Sponsors & Cosponsors:") {
                return [values[0].split("(<<<See All")[0]]
            }

            return values
        }

        return (
            <div className={classes.container}>
                {bigCache.fields.map(({ label, values }) => {
                    const formattedLabel = label.replace(":", "")

                    const formattedValues = formatValues(label, values)

                    if (
                        values &&
                        (values.constructor === Array || values instanceof Array || Array.isArray(values)) &&
                        values.length > 1 &&
                        label !== "Matching Snippets:"
                    ) {
                        const removeFullTextLink = (values) => {
                            // The Full Content has a link that allows user to go into profiles not allowed in the Mobile breakpoint
                            return values.map((item) => {
                                return item.includes("(see full text)") ? "" : item
                            })
                        }
                        const formattedSnippets = removeFullTextLink(values)

                        return (
                            <div className={classes.item} key={label}>
                                <div>{formattedLabel}</div>
                                <div className={classes.snippet}>
                                    <Snippets
                                        inlineId={inlineId}
                                        isExpanded
                                        isSearchify={isSearchify}
                                        snippets={formattedSnippets}
                                    />
                                </div>
                            </div>
                        )
                    } else if (
                        label !== "Matching Snippets:" &&
                        label !== "Stance:" &&
                        label !== "Priority:" &&
                        label !== "Full Content:"
                    ) {
                        return (
                            <div className={classes.item} key={label}>
                                <div>{formattedLabel}</div>
                                <div className={classes.text}>
                                    {formattedValues.map((value) => {
                                        const parsedValue = checkParseAlertString(value)
                                        // Disabling links per: https://quorumanalytics.atlassian.net/browse/COR-1807
                                        const parsedValueWithAnchorsStripped = DOMPurify.sanitize(parsedValue, {
                                            FORBID_TAGS: ["a"],
                                        })

                                        return renderText({
                                            lineData: parsedValueWithAnchorsStripped,
                                            isHtml: stringContainsHTMLMarkup(parsedValueWithAnchorsStripped),
                                            inlineId: inlineId,
                                            isSearchify: isSearchify,
                                        })
                                    })}
                                </div>
                            </div>
                        )
                    }

                    return null
                })}
            </div>
        )
    }

    return null
}
